'use client'

import type { TActiveAssetType } from '../../hooks/use-eld-asset-selection'
import { AssetNumberInput } from './asset-number-input'

interface IAssetInputsProps {
  confirmingAssetType?: TActiveAssetType | null
  currentTrailerNumber?: string | null
  currentTruckNumber?: string | null
  isConfirming: boolean
  isLoadingUpdate: boolean
  onTrailerInputChange?: (value: string) => void
  onTrailerRemoveClick?: () => void
  onTrailerSubmit?: () => void
  onTruckInputChange?: (value: string) => void
  onTruckRemoveClick?: () => void
  onTruckSubmit?: () => void
  trailerInputValue: string
  truckInputValue: string
}

/**
 * Renders trailer and truck number input fields for manual entry.
 */
export const AssetInputs = ({
  confirmingAssetType,
  currentTrailerNumber,
  currentTruckNumber,
  isConfirming,
  isLoadingUpdate,
  onTrailerInputChange,
  onTrailerRemoveClick,
  onTrailerSubmit,
  onTruckInputChange,
  onTruckRemoveClick,
  onTruckSubmit,
  trailerInputValue,
  truckInputValue
}: IAssetInputsProps) => (
  <>
    {!!onTrailerInputChange && !!onTrailerSubmit && !!onTrailerRemoveClick && (
      <AssetNumberInput
        assetType="trailer"
        confirmingAssetType={confirmingAssetType}
        currentValue={currentTrailerNumber}
        inputValue={trailerInputValue}
        isConfirming={isConfirming}
        isLoadingUpdate={isLoadingUpdate}
        onInputChange={onTrailerInputChange}
        onRemove={onTrailerRemoveClick}
        onSubmit={onTrailerSubmit}
      />
    )}
    {!!onTruckInputChange && !!onTruckSubmit && !!onTruckRemoveClick && (
      <AssetNumberInput
        assetType="truck"
        confirmingAssetType={confirmingAssetType}
        currentValue={currentTruckNumber}
        inputValue={truckInputValue}
        isConfirming={isConfirming}
        isLoadingUpdate={isLoadingUpdate}
        onInputChange={onTruckInputChange}
        onRemove={onTruckRemoveClick}
        onSubmit={onTruckSubmit}
      />
    )}
  </>
)
